import { BFormGroup } from './form-group';
import { pluginFactory } from '../../utils/plugins';
var FormGroupPlugin =
/*#__PURE__*/
pluginFactory({
  components: {
    BFormGroup: BFormGroup,
    BFormFieldset: BFormGroup
  }
});
export { FormGroupPlugin, BFormGroup };
export default FormGroupPlugin;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/esm/components/form-group/index.js
// module id = KoNO
// module chunks = 21